module.exports = __webpack_public_path__ + "media/instruction.6824e001.mp4";